export default {"src":"/_next/static/media/next-arrow-step-one-image.78dcc193.svg","height":70,"width":71,"blurWidth":0,"blurHeight":0};